document.addEventListener('click', function (event) {
      try {
        // Check if the clicked element is a navigation link
        if (event.target.tagName === 'A' && event.target.closest('.nav-items__list')) {
          let clickedElement = event.target;
          let menuHierarchy = [];
          let currentLevel = clickedElement;
    
          // Traverse up through the levels to get the hierarchy
          while (currentLevel) {
            let levelText = currentLevel.querySelector('a')?.textContent?.trim();
            if (levelText) {
              menuHierarchy.unshift(levelText); // Add to the beginning of the array
            }
            currentLevel = currentLevel.parentElement.closest('li');
          }
    
          // Construct the payload
          const payload = {
            event_name: 'nav_click',
            clicked_item: clickedElement.textContent.trim(),
            menu_hierarchy: menuHierarchy,
          };
    
          // Log the payload for testing
          console.log('Navigation Click Payload:', payload);
    
          // Publish the event using Shopify analytics
          Shopify.analytics.publish('nav_click', payload);
        }
      } catch (error) {
        console.error('Error processing navigation click:', error);
      }
    });